import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Avatar, AvatarUpdateRequest, Paginated, DeleteAllAvatarsResponse } from '@app/core/api/avatar';
import { Gender } from '@app/shared/models';

export const AvatarActions = createActionGroup({
  source: 'Avatar',
  events: {
    // Load avatars
    'Load Avatars': props<{ page?: number; size?: number }>(),
    'Load Avatars Success': props<{ response: Paginated<Avatar> }>(),
    'Load Avatars Failure': props<{ error: string }>(),

    // Create avatar
    'Create Avatar': props<{ image: File; faceName?: string; gender?: Gender }>(),
    'Create Avatar Success': props<{ avatar: Avatar }>(),
    'Create Avatar Failure': props<{ error: string }>(),

    // Get avatar status (for checking creation progress)
    'Get Avatar Status': props<{ characterUid: string }>(),
    'Get Avatar Status Success': props<{ avatar: Avatar }>(),
    'Get Avatar Status Failure': props<{ error: string }>(),

    // Update avatar
    'Update Avatar': props<{ id: string; updates: AvatarUpdateRequest }>(),
    'Update Avatar Success': props<{ avatar: Avatar }>(),
    'Update Avatar Failure': props<{ error: string }>(),

    // Delete avatar
    'Delete Avatar': props<{ id: string }>(),
    'Delete Avatar Success': props<{ id: string }>(),
    'Delete Avatar Failure': props<{ error: string }>(),

    // Delete all avatars
    'Delete All Avatars': emptyProps(),
    'Delete All Avatars Success': props<{ response: DeleteAllAvatarsResponse }>(),
    'Delete All Avatars Failure': props<{ error: string }>(),

    // Set active avatar (updates user preferences with active_avatar_id)
    // Note: activeAvatar is derived from preferences, not stored separately
    'Set Active Avatar': props<{ avatarId: string }>(),
    'Set Active Avatar Success': emptyProps(),
    'Set Active Avatar Failure': props<{ error: string }>(),

    // Remove active avatar (clears active_avatar_id from preferences)
    'Remove Active Avatar': emptyProps(),
    'Remove Active Avatar Success': emptyProps(),
    'Remove Active Avatar Failure': props<{ error: string }>(),

    // Initialize avatars (loads avatars list)
    // Note: No sync needed - activeAvatar is derived from preferences
    'Initialize Avatars': emptyProps(),
    'Initialize Avatars Success': emptyProps(),
    'Initialize Avatars Failure': props<{ error: string }>(),

    // Clear avatars (on logout)
    'Clear Avatars': emptyProps(),

    // Invalidate cache
    'Invalidate Cache': emptyProps(),
  }
});
